export default function TitleCaseFilterFactory() {
  return function titleCaseFilter(str) {
    if (!str) {
      return str;
    }
    return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  };
}



// WEBPACK FOOTER //
// ./src/filters/title-case.filter.js